export const USER_REQUEST = "USER_REQUEST";
export const USER_SUCCESS = "USER_SUCCESS";
export const USER_ERROR = "USER_ERROR";

export const AUTHENTICATE = "AUTHENTICATE";
export const LOGOUT = "LOGOUT";

export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

export const UI_TOGGLE_LEFT_NAV = "UI_TOGGLE_LEFT_NAV";
export const UI_TOGGLE_RIGHT_NAV = "UI_TOGGLE_RIGHT_NAV";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
